export const CONNECT = 'connect';
export const DISCONNECT = 'disconnect';
export const GET_INSTANCE = 'get_instance';
export const ADD_SOURCE = 'add_source';
export const REMOVE_SOURCE = 'remove_source';
export const EDIT_SOURCE = 'edit_source';
export const SOURCE_ID = 'created_source_id';
export const ADD_SHORTLIST = 'add_shortlist';
export const REMOVE_SHORTLIST = 'remove_shortlist';



// WEBPACK FOOTER //
// ./src/action_types/ioActionTypes.ts